/*
 * Widget that allows filtering a list of users by their status
 */

define(["marionette", "./template/userStatusFilterTemplate.html"], function (
  Marionette,
  UserStatusFilterTemplate,
) {
  "use strict";

  const UserStatusFilterView = {};

  UserStatusFilterView.userStatusFilterView = Marionette.ItemView.extend({
    template: UserStatusFilterTemplate,
    events: {
      "input #userStatusFilter": function () {
        const userStatusFilterEl = this.$el.find("#userStatusFilter");
        this.trigger("change:userStatusFilter", +userStatusFilterEl.val());
      },
    },
  });

  return UserStatusFilterView;
});
